import React from 'react'
import FooterContacto from '../footer/contacto'
import Footer from '../pricesmart/footer'
import Layout from './default'

export default ({ children, contacto, disclaimer }) => (
  <Layout>
    <div>
      {children}
      <FooterContacto contacto={contacto} disclaimer={disclaimer} />
      <Footer contacto={contacto} />
    </div>
  </Layout>
)
